import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';

export default class SensorBar extends Phaser.GameObjects.Image {
  constructor(scene, x, y) {
    super(scene, x, y, ABCyaPhaser.Images.DEFAULT_ATLAS, 'PlatformQuestion');

    this.waitingForHit = false;
    this.hitCallback = null;

    scene.physics.add.existing(this);

    this.body.setImmovable(true);
    this.body.checkCollision.up = true;
    this.body.checkCollision.left = false;
    this.body.checkCollision.right = false;
    this.body.checkCollision.down = false;

    this.visible = false;
  }

  deactivate() {
    this.active = false;
    this.visible = false;
    this.body.enable = false;
  }
}